/**
 * @generated SignedSource<<43f081e02d1109ccee51b6bd6a61fc9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VaultFieldValueInput = {
  fieldId: string;
  value?: string | null;
};
export type VaultFieldInput_createVaultFieldValues_Mutation$variables = {
  values?: ReadonlyArray<VaultFieldValueInput> | null;
  vaultId: string;
};
export type VaultFieldInput_createVaultFieldValues_Mutation$data = {
  readonly createVaultFieldValues: {
    readonly vault: {
      readonly fieldValues: ReadonlyArray<{
        readonly field: {
          readonly id: string;
        };
        readonly id: string;
        readonly value: string;
      }>;
      readonly id: string;
    };
  } | null;
};
export type VaultFieldInput_createVaultFieldValues_Mutation = {
  response: VaultFieldInput_createVaultFieldValues_Mutation$data;
  variables: VaultFieldInput_createVaultFieldValues_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "values"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "values",
            "variableName": "values"
          },
          {
            "kind": "Variable",
            "name": "vaultId",
            "variableName": "vaultId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "VaultsCreateVaultFieldValuesMutationPayload",
    "kind": "LinkedField",
    "name": "createVaultFieldValues",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Vault",
        "kind": "LinkedField",
        "name": "vault",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultFieldValue",
            "kind": "LinkedField",
            "name": "fieldValues",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VaultFieldInput_createVaultFieldValues_Mutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VaultFieldInput_createVaultFieldValues_Mutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "aa7bbbb928e7597ab7f7731ed0e6c7c5",
    "id": null,
    "metadata": {},
    "name": "VaultFieldInput_createVaultFieldValues_Mutation",
    "operationKind": "mutation",
    "text": "mutation VaultFieldInput_createVaultFieldValues_Mutation(\n  $vaultId: ID!\n  $values: [VaultFieldValueInput!]\n) {\n  createVaultFieldValues(input: {vaultId: $vaultId, values: $values}) {\n    vault {\n      id\n      fieldValues {\n        id\n        field {\n          id\n        }\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b53007120dfe634745a90d3dd54aafaa";

export default node;
